<template>
    <div class="blog-wrap">
        <img :src="require(`./../assets/${box.imageName}`)"/>
        <div>
            <a class="a-link" :href="box.href" target="_blank">{{$t(box.title)}}</a><br>
            <div>
                <a class="a-link" :href="box.href" target="_blank">
                    {{$t('app.buttons.learn_more')}}
                    <i class="m-l-8 fz-10 fas fa-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BlogBox',
    props:{
        box: {
            type: Object,
            default: true
        }
    }
}
</script>
<style lang="scss">
    .blog-wrap {
        height: 235px;
        border-radius: 4px;
        border: 1px solid $line-color;
        overflow: hidden;
        position: relative;
        margin-bottom: 24px;
        img{
            width: 100%;
            object-fit: cover;
        }
        > div {
            padding: 16px;
            .a-link {
                font-weight: 600;
                color: $primary-color-light;
            }
            > div {
                position: absolute;
                bottom: 16px;
                .a-link {
                    font-weight: normal;
                    color: $text-color-secondary;
                }
            }
        }
    }
</style>
